import { CHALLAN_LODING_GIF } from '@components/MainWidget/common/widgetImagesConstant'
import {
  CHALLAN_WIDGET_LANDING,
  FASTAG_WIDGET_LANDING,
  HSRP_WIDGET_LANDING,
  RTO_WIDGET,
} from '@components/Product/ProductWidget/constants'
import { widgetJourney } from '@configs/segmentEvents.config'
import { ChallanCard } from '@interfaces/landingWidget'

export const newChallanLoadingScreen = [
  {
    icon: CHALLAN_LODING_GIF,
    alt: 'Loading',
    text: 'Checking the Govt. portal and state RTOs...',
  },
  {
    icon: CHALLAN_LODING_GIF,
    alt: 'Loading',
    text: 'Fetching your challan details...',
  },
]

export const newVehicleInfoLoadingScreen = [
  {
    icon: CHALLAN_LODING_GIF,
    alt: 'Loading',
    text: 'Fetching your vehicle details…',
  },
  {
    icon: CHALLAN_LODING_GIF,
    alt: 'Loading',
    text: 'Match found. Preparing your report…',
  },
]

export const newFastagLoadingScreen = [
  {
    icon: CHALLAN_LODING_GIF,
    alt: 'Loading',
    text: 'Fetching FASTag balance...',
  },
]

export const newHsrpLoadingScreen = [
  {
    icon: CHALLAN_LODING_GIF,
    alt: 'Loading',
    text: 'Verifying vehicle info...',
  },
]

export const LOADING_SCREEN_CONTENT = {
  [CHALLAN_WIDGET_LANDING]: newChallanLoadingScreen,
  [RTO_WIDGET]: newVehicleInfoLoadingScreen,
  Default: newChallanLoadingScreen,
}

export const newChallanMobileModal = {
  heading: 'Your challan info is now  available on the ACKO app',
  subHeading: 'Get access to exclusive app features',
  cards: [
    {
      icon: 'https://acko-cms.ackoassets.com/wallet_1_c48cc52903.webp',
      alt: 'Loading',
      text: 'Pay challans in one tap',
    },
    {
      icon: 'https://acko-cms.ackoassets.com/Verify_1_c997ce78fd.webp',
      alt: 'Loading',
      text: 'Get rewards for driving safe',
    },
    {
      icon: 'https://acko-cms.ackoassets.com/refresh_2_1_989a5145a5.webp',
      alt: 'Loading',
      text: 'View all past challans ',
    },
  ],
  mobileHomeScreen: 'https://acko-cms.ackoassets.com/i_Phone_14_Pro_Max_b283c704d5.webp',
  buttomText: 'Download the app',
  buttonSubtext: 'Takes less than 1 minute',
}

export const newChallanMobileFallbackModal = {
  heading: 'DO MORE THAN CHALLANS',
  subHeading: '8 million vehicle owners find our app useful. You will too.',
  cards: [
    {
      icon: 'https://acko-cms.ackoassets.com/Challans_detail_page_9412947843.jpg',
      cardText: 'Recharge FASTag',
      cardSubtext: 'Get low balance alerts and recharge in one tap ',
    },
    {
      icon: 'https://acko-cms.ackoassets.com/Challans_detail_page_9412947843.jpg',
      cardText: 'Get your car serviced',
      cardSubtext: 'FREE pick-up and drop to any car service centre',
    },
    {
      icon: 'https://acko-cms.ackoassets.com/Challans_detail_page_9412947843.jpg',
      cardText: 'Check resale price',
      cardSubtext: 'Find out how much you can get for your car',
    },
  ],
  buttomText: 'Get the app',
}

export const sampleCards: ChallanCard[] = [
  {
    title: 'Recharge FASTag',
    description: 'Get low balance alerts and recharge in one tap',
    imageUrl: 'https://acko-cms.ackoassets.com/i_Phone_14_Pro_Max_1a2d89ea1f.webp',
  },
  {
    title: 'Get your car serviced',
    description: 'FREE pick-up and drop to any car service center',
    imageUrl: 'https://acko-cms.ackoassets.com/i_Phone_14_Pro_Max_1a2d89ea1f.webp',
  },
  {
    title: 'Check resale price',
    description: 'Find out how much you can get for your car',
    imageUrl: 'https://acko-cms.ackoassets.com/i_Phone_14_Pro_Max_1a2d89ea1f.webp',
  },
]

export const getWidgetId = widgetType => `#${widgetJourney[widgetType]}-widget-landing-widget`
export const DO_MORE_THAN_CHALLANS = 'DO MORE THAN CHALLANS'
export const DO_MORE_SUB_HEADING = '8 million vehicle owners find our app useful. You will too.'
export const DO_MORE_BUTTON_TEXT = 'Get the app'
export const TAKES_LESS_TIME = 'Takes less than 1 minute'

export const PHONE_NUMBER_PREFIX = '+91'
export const ENTER_VALID_MOBILE_NUMBER = 'Enter a valid mobile number'
export const ENTER_CHALLAN_MOBILE_NUMBER_INFO = 'Enter your mobile number to get accurate challan info'
export const ENTER_HSRP_MOBILE_NUMBER_INFO = 'Enter mobile number linked to your vehicle'
export const ENTER_VEHICLE_INFO_NUMBER_INFO = 'Enter your mobile number to access your vehicle report'
export const ENTER_INFO_MAPPING = {
  [CHALLAN_WIDGET_LANDING]: ENTER_CHALLAN_MOBILE_NUMBER_INFO,
  [HSRP_WIDGET_LANDING]: ENTER_HSRP_MOBILE_NUMBER_INFO,
  [RTO_WIDGET]: ENTER_VEHICLE_INFO_NUMBER_INFO,
  Default: ENTER_CHALLAN_MOBILE_NUMBER_INFO,
}
export const CHALLAN_LINKED_TO_MOBILE = 'Some challans could also be linked to your mobile number'
export const VALID_PHONE_NUMBER_REQUIRED = 'We need your number to fetch verified RTO information'
export const DESCRIPTION_MAPPING = {
  [CHALLAN_WIDGET_LANDING]: CHALLAN_LINKED_TO_MOBILE,
  [RTO_WIDGET]: VALID_PHONE_NUMBER_REQUIRED,
  Default: VALID_PHONE_NUMBER_REQUIRED,
}
export const ENTER_MOBILE_NUMBER = 'Enter your mobile number'
export const NEVER_SPAM_OR_SHARE = 'We’ll never spam you or share your info'
export const PROMISE_NOT_TO_SPAM = 'We promise not to spam you'
export const PHONE_NUMBER_INFO = {
  [CHALLAN_WIDGET_LANDING]: NEVER_SPAM_OR_SHARE,
  [RTO_WIDGET]: PROMISE_NOT_TO_SPAM,
  Default: NEVER_SPAM_OR_SHARE,
}
export const HANDLE_KEY_BACKSPACE = 'Backspace'
export const HANDLE_KEY_DELETE = 'Delete'
export const PRODUCT_NAME = 'ChallanWidgetNew'
export const BUTTON_CTA = 'Continue'

export const VIEW_CHALLANS_ON_APP = 'View challans on the app'
export const RECHARGE_FASTAG_ON_APP = 'Recharge FASTag on the app'
export const BOOK_HSRP_ON_APP = 'Book HSRP on the app'
export const downloadButtonText = {
  [CHALLAN_WIDGET_LANDING]: VIEW_CHALLANS_ON_APP,
  [FASTAG_WIDGET_LANDING]: RECHARGE_FASTAG_ON_APP,
  [HSRP_WIDGET_LANDING]: BOOK_HSRP_ON_APP,
  [RTO_WIDGET]: VIEW_CHALLANS_ON_APP,
  Default: 'Download the app',
}

export const MOBILE_NUMBER_LOCK = 'https://acko-cms.ackoassets.com/blocked_solid_rounded_1_8b0a6b21ee.webp'

export const INDIA_LOGO = 'https://acko-cms.ackoassets.com/INDIA_reg_No_icon_without_bg_e92d8c7f7b.svg'
export const DEFAULT_CHALLAN_CAR_IMAGE = 'https://auto.ackoassets.com/central-app/features/asset_v9/Car-big-default.png'
export const DEFAULT_CHALLAN_BIKE_IMAGE =
  'https://auto.ackoassets.com/central-app/features/asset_v9/Bike-big-default.png'
export const ACKO_LOGO_PURPLE = 'https://acko-cms.ackoassets.com/Acko_App_icon_challan_f4ee5f8864.svg'
export const CHALLAN_NOTIFICATION_HEADING = 'Monthly reward unlocked'
export const CHALLAN_NOTIFICATION_SUBHEADING = 'for checking your challans'
export const CHALLAN_MWEB_GIFT_IMAGE_SRC = 'https://acko-cms.ackoassets.com/Gift_c484ac574d.svg'

export const defaultVehicleImage = {
  PRIVATE_CAR: DEFAULT_CHALLAN_CAR_IMAGE,
  TWO_WHEELER: DEFAULT_CHALLAN_BIKE_IMAGE,
  Default: DEFAULT_CHALLAN_CAR_IMAGE,
}
